import { getToken, getUser } from "../../Utils/Common";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

export const searchTerminal = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "terminals/get",
            {
                requester: getUser(),
                token: getToken(),
                terminal_id: data.id,
                name_search: data.name,
                branch_id: data.branch_id,
                page: data.page
            }
        );
        return { data: response };
    } catch (error) {
        return { error: error.response };
    }
};

//POST
export const createTerminal = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "terminals/create",
            {
                requester: getUser(),
                token: getToken(),
                branch_id: data.branch_id,
                name: data.name,
                status: data.status,
                details: data.details,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateTerminal = async (data) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "terminals/update",
            {
                requester: getUser(),
                token: getToken(),
                terminal_id: data.id,
                branch_id: data.branch_id,
                name: data.name,
                status: data.status,
                details: data.details,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};

export const deleteTerminals = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "terminals/delete",
            {
                requester: getUser(),
                token: getToken(),
                terminal_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error.response };
    }
};
